import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=8d4ac952"
import script from "./Alert.js?vue&type=script&lang=js&external"
export * from "./Alert.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports